import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function BetaFeedbackModal({ show, on_hide }) {
	const navigate = useNavigate();

	return (
		<Modal show={show} onHide={on_hide} dialogClassName="intro-modal-dialog" centered>
			<Modal.Header closeButton>
				<Modal.Title>Thank You for Beta Testing</Modal.Title>
			</Modal.Header>
			<Modal.Body className="intro-modal-body">
				<p>Thank you for participating in the AI Call Trainer beta. Your involvement is genuinely appreciated.</p>
				<p>We would love to hear your thoughts. Please use the <strong>Feedback</strong> link in the sidebar to share any bugs, suggestions, or general impressions.</p>
				<p>Your feedback directly shapes the product.</p>
			</Modal.Body>
			<Modal.Footer className="intro-modal-footer">
				<Button
					className="intro-modal-btn"
					onClick={function() {
						on_hide();
						navigate('/feedbackform');
					}}>
					Leave Feedback
				</Button>
				<Button variant="secondary" onClick={on_hide}>
					Maybe Later
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default BetaFeedbackModal;
